import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CourseProgressSelection } from '@/data/hook/student-dashboard/useStudentDashboardCourseProgresses';

export const COURSE_PARAM = 'course';

export default function useSearchParamCourseProgressSelection(): CourseProgressSelection {
  const [searchParams, setSearchParams] = useSearchParams();
  const slug = searchParams.get(COURSE_PARAM) ?? undefined;

  return useMemo(
    () => ({
      slug,
      fallbackToFirst: true,
      select: ({ coursePath }) => {
        const params = new URLSearchParams(searchParams);
        params.set(COURSE_PARAM, coursePath.slug);
        setSearchParams(params, { replace: true });
      },
    }),
    [slug, searchParams, setSearchParams],
  );
}
